// Enum for all trackers
export enum TrackersEnum {
  // generic
  DEFAULT = 'default',
  APPLICATIONS = 'applications',
  OPPORTUNITIES = 'opportunities',
  RELATIONSHIPS = 'relationships',
  UNDERWRITING = 'underwriting',


  SETTINGS = 'settings',
  MESSAGECENTER = 'message Center',
  ADMINSETTINGS = "adminsettings",

  // others
  PROSPECTING = 'prospecting',
  CASETRACKER = "case tracker",
  DASHBOARD = "dashboard"
}

export enum TrackerViewsEnum {
  GRID = 'grid',
  LIST = 'list'
}

export interface ITrackerConfigModel {
  type: TrackersEnum,                          // required - For which tracker should it be displayed
  title: string,                              // required - main title to be displayed
  
  displayCount: boolean,                      // default true - should count be displayed beside the title 
  searchLead: boolean,                        // default true - should the lead search be provided
  filterLead: boolean,                        // default true - should the filter lead be provided
  swicthDisplay: boolean,                     // default true - should the grid and list view switch be provided

  displayProduct?: boolean,                   // default false - should product be displayed above the title 
  createLead?: boolean,                       // default false - should the create lead button be provided
  // displaySecondHeader?: boolean,           // default false - should the second header be displayed (button groups and sorting mainly for relationships)
  // displaySlider?: boolean,                 // default false - should the slider be shown in second header
  displayViewSort?: boolean,                  // default false - should the sort options based on view
}

// Todo: this is an old model replace with new fields
export interface ILeadsResponseModel {
  clientId: string | number | null | undefined;
  email: string | null;
  firstName: string | null;
  lastName: string | null;
  phone: string | null;
  status: string | null;
  // for displying status in UI
  displayStatus?: string | null;
  questionarieId?: number | null;
  orgId: number|string | undefined|null;
  daysInStatus: string | null;
  company: string | null;
  estimatedMonthlyDeposit: string |  null;
  businessState: string | null
  businessAddress: string | null;
  businessCity: string | null;
  businessZipCode: string | null;
  phoneExt: string | null;
  isInvitationExpired: string | null;
  unitSuite: string | null;
  progressState: string | null;
  uniqueId?: string | null;
  holdingCompany: string | null;
  estimatedFees?: number | null;
  operatingStates: string | null;
  numberOfLocations?: number | null;
  qualificationCompletedPercentage?:number|null
  firstAccountOpened?: Date | string | null;
  numberOfAccounts?: number | null;
  leadType: string | null;
  dba: string | null;
  statusChangedDate: string | null;
  statusChangedTime: string | null;
  interviewDate:string | null;
  fromTime: string | null;
  amPm:string | null;
  primary: boolean | null;
  invitationSent: boolean| null;
  bussiessCategory?: string | null;
  businessType: string | null;
  reviewPercentage:number|null;
  templateId?: string | null;
  mcc?: string | null;
  method?: string | null;
  assignToName?: string | null;
  userCompany?: string | null;
  clientUuid?: string | null;
  businessCategory?: string | null;
  toTime?: string | null;
  statusDate?: string | null;
  companyName?: string | null;
  volume?: string | null;
  assignTo?: number | null;
  lastContacted?: string | null;
  locationName?: string | null;
  prevetMakeDecision?: boolean | null;
  estccvolume?: number | null;
  esttransccount?: number | null;
  daychange?: number | null;
  daychangepercentage?: number | null;
}

export interface ISortOptionsModel {
  sortColumn: string;
  sortDirection: string;
}
